<template>
  <div>
    <ul id="nav" :class="{'show': navShow}">
      <li class="current"><a href="javascript:;"><i></i>活动介绍</a></li>
      <li><a href="javascript:;" @click="linkTo(2)">参赛证</a></li>
      <li><a href="javascript:;" @click="linkTo(3)">比赛成绩</a></li>
      <li><a href="javascript:;" @click="linkTo(4)">我的团队</a></li>
    </ul>

    <div class="header">
      <div class="header-box">
        <div class="label">报名时间</div>
        <p class="text">07月08日至07月31日</p>
        <div class="label label-second">线下报名地点</div>
        <a href="https://router.map.qq.com/short?l=738b38477de48dff274879e835ea00b4">
          <p class="text">1.杰丰集团3号楼618室</p>
        </a>
        <!-- <a href="https://router.map.qq.com/short?l=69fb1963f6d61f354677a18fe370a263">
          <p class="text">2.杭州市家禾雪纺仓库（葛家车村368号）物业办公室</p>
        </a> -->
        <a href="https://router.map.qq.com/short?l=740eb3c328b14f63bee1f6eaa9b006e2">
          <p class="text">2.服装综合体·葛家车村智造园区</p>
        </a>
      </div>

      <div class="enters-module">
        <div class="enters-item one" @click="linkTo(2)">
          参赛证
        </div>
        <div class="enters-item two" @click="linkTo(3)">
          我的成绩
        </div>
        <div class="enters-item three" @click="linkTo(4)">
          我的团队
        </div>
      </div>
    </div>

    <div id="container">
      <div class="section" id="intro">
        <h2 class="section-title">活动介绍</h2>
        <div>
          <strong class="section-sub-title">服装缝制实战精英大赛</strong>
        </div>
        <div style="margin: 0.2rem 0;">
          <span class="common-size orange">实战缝纫·技工大赛</span>
        </div>
        <p class="grey">
          为响应余杭3个全域建设，建立基础工人及工厂等级判定，建立核心产业工人资料库，验证建立小团队快返标准可复制模型。打造数字时尚新高地的号召，同时吸引服装产业优质专业制造人才，有效提高优秀人才进驻余杭的意愿，亿尚智能在各界领导单位的指导下，特举办本次服装技工大赛活动。
        </p>
        
      </div>
      <div class="section" id="bonus">
        <h2 class="section-title">奖金设定</h2>
        <div class="mbm-1">
          <strong class="section-sub-title orange">一等奖一组</strong>
        </div>
        <div class="mbm-3">
          <strong class="section-sub-title">A级认证+生产报酬+二万四千元奖金+赛事福利礼包+余杭区技工大赛精英赛奖励</strong>
        </div>
        <div class="mbm-1">
          <strong class="section-sub-title orange">二等奖两组</strong>
        </div>
        <div class="mbm-3">
          <strong class="section-sub-title">B级认证+生产报酬+赛事福利礼包+余杭区技工大赛精英赛奖励</strong>
        </div>
        <div class="mbm-1">
          <strong class="section-sub-title orange">三等奖三组</strong>
        </div>
        <div class="mbm-3">
          <strong class="section-sub-title">C级认证+生产报酬+赛事福利礼包+余杭区技工大赛精英赛奖励</strong>
        </div>
        <div class="mbm-1">
          <strong class="section-sub-title orange">入围奖若干组</strong>
        </div>
        <div class="mbm-3">
          <strong class="section-sub-title">D级认证+生产报酬+赛事福利礼包+余杭区技工大赛精英赛奖励</strong>
        </div>
      </div>
      <div class="section">
        <h2 class="section-title">赛制</h2>
        <div class="mbm-1">
          <strong class="section-sub-title orange">预赛</strong>
        </div>
        <div class="mbm-3">
          <strong class="section-sub-title">通过工艺单解读、产能预估两个模块的成绩综合评价，取前30组选手进入决赛。</strong>
        </div>
        <div class="mbm-1">
          <strong class="section-sub-title orange">决赛</strong>
        </div>
        <div class="mbm-3">
          <strong class="section-sub-title">每个小组在决赛期限内完成约5000元左右（约200件）生产订单，根据完成速度、质量综合评定小组成绩。</strong>
        </div>
      </div>
      <div class="section" id="rules">
        <!-- <h2 class="section-title">大赛细则</h2> -->
        <!-- <div class="mbm-1">
          <strong class="section-sub-title orange">预赛时间地点</strong>
        </div> -->
        <h2 class="section-title">预赛时间地点</h2>
        <div>
          <strong class="section-sub-title">2019.08.05-08.07</strong>
        </div>
        <a href="https://router.map.qq.com/short?l=9eb93bb38ad417b53e681e655a81c7bd">
          <div class="address mbm-3">
            <strong class="section-sub-title">余杭区 • 浙江省服装产业创新服务综合体</strong>
          </div>
        </a>
        <!-- <div class="mbm-1">
          <strong class="section-sub-title">赛制-预赛</strong>
        </div>
        <p class="grey-32">
          参赛选手通过成品样衣展示、工艺单解读、产能预估三个模块的成绩综合评价，取排名前80名的选手进入决赛
        </p> -->
      </div>

      <div class="section" id="traffic">
        <h2 class="section-title">交通情况</h2>
        <div>
          <strong class="section-sub-title">自驾：</strong>
        </div>
        <p class="grey">
          导航至杭州余杭区浙江省服装产业创新服务综合体
        </p>
        <div style="margin-top: 0.5rem;">
          <strong class="section-sub-title">公交：</strong>
        </div>
        <p class="grey">
          东西大道口站：492路、492路区间、761路
        </p>
        <div style="margin-top: 0.5rem;">
          <strong class="section-sub-title">地铁：</strong>
        </div>
        <p class="grey">
          东西大道口站：492路、492路区间、761路
        </p>
        <div style="margin-top: 0.3rem;">
          <a href="https://router.map.qq.com/short?l=9eb93bb38ad417b53e681e655a81c7bd">
            <img src="../assets/map.jpg" alt="">
          </a>
        </div>
      </div>

      <div class="section" id="attention">
        <h2 class="section-title">注意事项</h2>
        <div class="attention-item">可以携带一件自己生产的成品样衣，可作为额外加分选项，有助于提高预赛成绩</div>
        <div class="attention-item">比赛请提前15分钟到场</div>
        <div class="attention-item">请务必携带身份证明，例如身份证。</div>
      </div>
      <div class="section" id="hotline">
        <h2 class="section-title">咨询热线 <small class="small">(工作时间  8:30-18:30)</small></h2>
        <div class="mbm-1">
          <strong class="section-sub-title">马莫勤 &nbsp;&nbsp;&nbsp;&nbsp; 138&nbsp;&nbsp;5717&nbsp;&nbsp;9132</strong>
          <a class="tel" href="tel:13857179132">点击拨打</a>
        </div>
        <div class="mbm-1">
          <strong class="section-sub-title">刘鹏程 &nbsp;&nbsp;&nbsp;&nbsp; 153&nbsp;&nbsp;8406&nbsp;&nbsp;3083</strong>
          <a class="tel" href="tel:15384063083">点击拨打</a>
        </div>
      </div>
      <div class="section">
        <p class="grey company clearfix">
          <strong>主办单位</strong>
          <span style="float: left;">
            余杭区区委组织部人才办<br>
            余杭区总工会<br>
            余杭区人事局<br>
            余杭区区财政局
          </span>
        </p>
        <p class="grey company clearfix">
          <strong>承办单位</strong>
          <span style="float: left;">
            临平新城管委会<br>
            浙江省服装产业创新服务综合体<br>
            杭州亿尚智能科技有限公司
          </span>
        </p>
      </div>

      <div class="wechat-attention">
        <img class="img" src="../assets/wechat_code.png" alt="">
        <p class="text">长按图片关注公众号</p>
        <p class="text">成绩将在公众号上进行公布</p>
      </div>
     

       
      <div class="bottom-line"> 到底啦！ 亲~</div>
      <div style="height: 2rem;"></div>
    </div>
    <div class="bottom-btn" v-if="showApplyBtn">
      <div class="login" @click="toLogin">已报名用户<br>请点这里</div>
      <div class="apply" @click="toApply">线上报名</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'index',
  data () {
    return {
      tab: 0,
      content: ''
    }
  },
  created () {

  },
  computed: {
    ...mapState({
      showApplyBtn: state =>  state.token ?  false : true
    }),
    navShow: function() {
      return this.tab > 0 ? true : false;
    }
  },
  mounted() {
    this.scrollHandle();
  },
  methods: {
    toLogin() {
      this.$router.push('/login');
    },
    toApply() {
      this.$router.push('/apply');
    },
    
    scrollHandle() {
      let top1 = document.querySelector('#intro').offsetTop;
      window.addEventListener('scroll', (ev) => {
        let e = ev || window.event;
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollTop < top1 - 60) {
          this.tab = 0
        } else {
          this.tab = 1
        }
      })
    },
    linkTo(index) {
      switch (index) {
        case 1:
          this.$router.push('/index')
          break;
        case 2:
          this.$router.push('/certificate')
          break;
        case 3:
          this.$router.push('/score')
          break;
        case 4:
          this.$router.push('/team')
      }
    },
    goMap () {
      // this.$router.push('/map-position')
      wx.openLocation({
        latitude: 30.3843, // 纬度，浮点数，范围为90 ~ -90
        longitude: 120.291, // 经度，浮点数，范围为180 ~ -180。
        name: '杭州•艺尚小镇•文化街区一期1号楼', // 位置名
        address: '', // 地址详情说明
        scale: 20, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      });
    } 
  }
}
</script>

<style scoped>
		img { width: 100%; }
		#nav { z-index: 2; position: fixed; top: -0.8rem; opacity: 0; transition: 0.2s; width: 100%; padding: 0 0.3rem; max-width: 768px; height: 0.8rem; background: #fff; box-shadow: 0 0 10px #ccc; display: flex; justify-content: space-between;}
		#nav li {line-height: 0.8rem; text-align: center; }
		#nav li a { text-decoration: none; display: block; color: #333; font-size: 0.3rem;}
		#nav li.current a { color:#de7a31;   }
		#nav li i { width: 0.25rem; height: 0.27rem; display: inline-block; vertical-align: middle; margin-right: 2px; }
		#nav li.current i {background: url(../assets/icon_select.png) no-repeat; background-size: cover;}
    #nav.show {top: 0; opacity: 1;}

		.header {position: relative;}
    .header-img { width: 100%;}
    .header-box { box-sizing: border-box; height: 4rem; background: url(../assets/home_banner.jpg) no-repeat; background-size: cover; padding: 0.5rem 0.4rem 0 3.3rem;}
    .header-box .label { font-size: 0.28rem; color: #fff; margin-bottom: 0.1rem;}
    .header-box .label-second { margin-top: 0.3rem;}
    .header-box .text { font-size: 0.28rem; color: #fff;}

    .enters-module { padding: 0.5rem 0.9rem 0.9rem; display: flex; justify-content: space-between; }
    .enters-item { width: 1.5rem; height: 1.7rem; padding-top: 1.1rem; border: 1px solid #de7a31; text-align: center; color: #333; font-size: 0.3rem;  box-shadow: 4px 4px 10px #ccc}
    .enters-item.one { background: url(../assets/icon_card.png) no-repeat center 0.24rem/0.6rem; }
    .enters-item.two { background: url(../assets/icon_score.png) no-repeat center 0.24rem/0.6rem; }
    .enters-item.three { background: url(../assets/icon_building.png) no-repeat center 0.24rem/0.6rem; }

		.section {padding: 0 0.4rem 0.8rem;}
		.section-title { padding: 0.5rem 0 0.3rem; font-size: 0.4rem; color: #333;}
    .section-title .small {font-size: 0.28rem;}
    .section-sub-title { font-size: 0.32rem; color: #333; }
    .section .common-size { font-size: 0.28rem; }
    .section .orange {  color: #de7a31;}
    .section .grey { font-size: 0.28rem; color: #a3a3a3;}
    .section .grey-32 { font-size: 0.32rem; color: #a3a3a3;}
    .section .mbm-1 { margin-bottom: 0.1rem; }
    .section .mbm-3 { margin-bottom: 0.3rem; }
    .section .address { padding-left: 0.55rem; background: url(../assets/icon_map.png) no-repeat left center/0.31rem 0.35rem;}
		.section p.grey {margin-top: 0.2rem; text-align: justify;}
		.section p.company {margin-top: 0.3rem;}
    .section p.company strong {float: left; font-size: 0.32rem; color: #666; padding-right: 0.3rem;}
    .section p.company span { font-size: 0.28rem; color: #666;}
    .section .tel { font-size: 0.3rem; margin-left: 0.3rem; line-height: 0.54rem; color: blue; text-decoration: underline;}

		.attention-item { padding-left: 0.54rem; background: url(../assets/icon_notice.png) no-repeat left 0.04rem/0.38rem 0.38rem; font-size: 0.3rem; color: #666; margin-bottom: 0.5rem;}
		
		.bottom-btn {position: fixed; bottom:0; width: 100%; max-width: 768px; height: 1.1rem; background: #fff; box-shadow: 0 0 10px #999; }
		.bottom-btn .login {float: left; width: 30%; height: 1.1rem; line-height: 1.4; text-align: center; font-size: 0.28rem; color: #333; padding-top: 0.2rem; }
		.bottom-btn .apply {float: left; width: 70%; height: 1.1rem; background: #df7a32; line-height: 1.1rem; text-align: center; font-size: 0.32rem; color: #fff;}

		.clearfix:after { visibility: hidden; display: block; font-size: 0; content: " "; clear: both; height: 0; }     
		.clearfix { display: block; } 

		.bottom-line {text-align: center; color: #999; font-size: 0.24rem; height: 0.6rem; width: 100%; line-height: 0.6rem; margin-top: 1rem;  position: relative;}
		.bottom-line::before, .bottom-line::after { position: absolute; top: 0.3rem; height: 1px; content: ' '; -webkit-transform: scaleY(.5); transform: scaleY(.5); width: 2rem; background: #a1a1a1; z-index: 1;}
		.bottom-line::before { left: 0.9rem; }
		.bottom-line::after { right: 0.9rem; }

    .wechat-attention .img {display:block; margin: 0 auto; width: 3.6rem;}
    .wechat-attention .text {text-align: center; color: #999; font-size: 0.3rem;}
</style>

